"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setNormal = exports.setFade = exports.assign = exports.registerAll = void 0;
var common_sidecar_1 = require("../main/common-sidecar");
// import { DiamondWipePipelinePostFX } from './DiamondWipePipeline'
var registerAll = function () {
    var game = common_sidecar_1.common.getPhaserScene().game;
    // console.log('game', game)
    // console.log('HueRotatePipeline', HueRotatePipeline)
    // console.log('attempt to create hue')
    // let wgl = game.renderer as Phaser.Renderer.WebGL.WebGLRenderer
    // let pipelines = wgl.pipelines as any
    var sc = common_sidecar_1.common.getPhaserScene();
    // console.log('set post pipeline')
    // sc.cameras.main.setPipeline(hueRotate as any)
    // pipelines.setPostPipeline(hueRotate)
};
exports.registerAll = registerAll;
var assign = function () {
    // const l =
    // let game = common.getPhaserScene().game
    // console.log('assign post pipeline')
    // const hueRotate = HueRotate.createClass(game)
    //l.setPostPipeline(new HueRotatePostFX(game))
    // underLayers
    //   .getMasterLayers()
    //   .location.setPostPipeline(DiamondWipePipelinePostFX)
    // underLayers
    //   .getMasterLayers()
    //   .hexmap.setPostPipeline(DiamondWipePipelinePostFX)
};
exports.assign = assign;
var setFade = function (layer) {
    // layer.setPostPipeline(DiamondWipePipelinePostFX)
};
exports.setFade = setFade;
var setNormal = function (layer) {
    // layer.resetPostPipeline()
};
exports.setNormal = setNormal;
